export default function isImage(url) {
  // regex to match file types from a string or URL string
  return /^https?:\/\/.+\.(jpg|jpeg|png)$/.test(url);
}
